import React, { useState } from "react";
import axios from "axios";
import { Form, Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../redux/alertsSlice";
import toast from "react-hot-toast";
import Layout from "../../components/layout";

function AdminUpload() {
  const [fileList, setFileList] = useState([]);
  const dispatch = useDispatch();

  const handleUpload = async () => {
    const formData = new FormData();
    fileList.forEach(file => {
      formData.append("images", file);
    });

    try {
      dispatch(showLoading());
      const response = await axios.post("/api/admin/upload-images", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success("Images uploaded successfully");
        setFileList([]);
      } else {
        toast.error("Failed to upload images");
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
      console.error("Error uploading images:", error);
    }
  };

  const handleBeforeUpload = (file) => {
    setFileList([...fileList, file]);
    return false;
  };

  const handleRemove = (file) => {
    setFileList(fileList.filter(item => item.uid !== file.uid));
  };

  return (
    <Layout>
    <Form layout="vertical" onFinish={handleUpload}>
      <Form.Item label="Upload Images">
        <Upload
          beforeUpload={handleBeforeUpload}
          onRemove={handleRemove}
          fileList={fileList}
          listType="picture"
        >
          <Button icon={<UploadOutlined />}>Select Files</Button>
        </Upload>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Upload
        </Button>
      </Form.Item>
    </Form>
    </Layout>
  );
}

export default AdminUpload;
